import * as React from 'react';
import { useCallback } from 'react';
import { Icon } from '@components/atoms/icon';
import { Typography } from '@components/atoms/typography';
import { useToast } from '@hooks/use-toast';
import type { SnackbarOrigin } from '@mui/material/Snackbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppTheme } from '@theme';
import styled from 'styled-components';

import { CheckMarkIcon, CloseIcon, ErrorMarkIcon, WarningIcon } from '../../icons';

import { Snackbar, ToastItem } from './styles';

const position: SnackbarOrigin = {
    vertical: 'top',
    horizontal: 'right',
};

const autoHide = 5000;

const Molecule = () => {
    const { toasts, hideToast } = useToast();

    const theme = useAppTheme();

    const matchesMobileSm = useMediaQuery(`(max-width:${theme.breakPoints.sm})`);

    const handleClose = useCallback(
        (id: string) => {
            hideToast(id);
        },
        [hideToast],
    );

    return (
        <React.Fragment>
            {toasts.map((toast) => (
                <Snackbar
                    key={toast.id}
                    open={true}
                    message={toast.message}
                    anchorOrigin={position}
                    onClose={() => {
                        handleClose(toast.id);
                    }}
                    autoHideDuration={autoHide}
                    style={{ top: matchesMobileSm ? 68 : 112 }}
                >
                    <ToastItem variant={toast.variant} data-testid='toast-container'>
                        <div className='status-icon-container'>
                            {toast.variant === 'success' && (
                                <CheckMarkIcon className='success-icon' />
                            )}
                            {toast.variant === 'warning' && (
                                <WarningIcon className='warning-icon' />
                            )}
                            {toast.variant === 'error' && <ErrorMarkIcon />}
                        </div>
                        <div className='content-container'>
                            <div className='header'>
                                <Typography variant='text-bold' color='primary-a7' tag='div'>
                                    {toast.title}
                                </Typography>
                                <div className='close-icon-container'>
                                    <Icon
                                        icon={<CloseIcon />}
                                        $clickable={true}
                                        onClick={() => {
                                            handleClose(toast.id);
                                        }}
                                    />
                                </div>
                            </div>
                            {!!toast.message && (
                                <Typography
                                    variant='small-text'
                                    color='secondary-a5'
                                    tag='div'
                                    className='message'
                                >
                                    {toast.message}
                                </Typography>
                            )}
                            {!!toast.content && (
                                <Typography
                                    variant='small-text'
                                    color='secondary-a5'
                                    tag='div'
                                    className='content'
                                >
                                    {toast.content}
                                </Typography>
                            )}
                        </div>
                    </ToastItem>
                </Snackbar>
            ))}
        </React.Fragment>
    );
};

export const ToastContainer = styled(Molecule)({});
